import * as DialogPrimitive from "@radix-ui/react-dialog";
import type { ComponentProps } from "react";

import { useDialogModal } from "../../context/InteractiveWindowContext";

export const Dialog = ({ modal, ...props }: ComponentProps<typeof DialogPrimitive.Root>) => {
  const shouldBeModal = useDialogModal();
  const resolvedModal = modal ?? shouldBeModal;

  return <DialogPrimitive.Root data-slot="dialog" modal={resolvedModal} {...props} />;
};
